<section class="page-section" id="advices">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h2 class="section-heading text-uppercase">Advices</h2>
        <h3 class="section-subheading">A little inside knowledge also helps</h3>
      </div>
    </div>
    <!-- <mat-accordion> -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <strong>Preparation for the interview:</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ol>
          <li>Go with one purpose: TO GET THE JOB! Go with a positive attitude</li>
          <li>Remember, when you apply for a job, your passions and capabilities must suit the position</li>
          <li>When the company phones you for an interview, ask the following information to prepare yourself for the
            interview:
            <ul>
              <li>Company address</li>
              <li>Information about position (or use the information in the advert)</li>
              <li>Will it be a panel interview?</li>
              <li>In what language will the interview be</li>
              <li>Will there be any tests before or after the interview</li>
              <li>What will the salary be</li>
            </ul>
          </li>
          <li>Get information about the company</li>
          <li>Learn your CV</li>
          <li>Prepare your answers on the questions attached</li>
          <li>The clothes you will wear must be relevant to the position</li>
          <li>Practice your body-language</li>
        </ol>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <strong>Practical tips:</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ol>
          <li>Be on time: preferably 5 – 10 minutes early</li>
          <li>Put your cell phone off</li>
          <li>Give a firm handshake</li>
          <li>Look the people straight in the eyes during the interview</li>
          <li>Sit correctly: sit comfortable upright, with an open body-language</li>
          <li>Do not ask to smoke; do not ask to drink something</li>
          <li>Try to be yourself all the time</li>
          <li>Be very honest all the time</li>
          <li>Speak loud and clearly</li>
        </ol>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <strong>Questions and how to answer them:</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ol>
          <li>Be prepared to answer questions about your previous jobs, as well as current job.</li>
          <li>On the question: What is your strong points
            <ul>
              <li>The WRONG answer is: I am friendly, loyal, hardworking, honest</li>
              <li>The RIGHT answer is:&nbsp; I am good in admin, I am good with figures, I am good with computers, I’m
                an organizer, I finish what I began, I function good under pressure, I give my everything to my work. I
                will work long hours, I prioritize my work, I will prove myself</li>
            </ul>
          </li>
          <li>Answer questions short, completely and relevant to the question</li>
          <li>Don’t just answer Yes or No</li>
          <li>Be aware not to do the interview with the interviewer</li>
          <li>Wait for the interviewer to finish his question before you answer</li>
          <li>Do not bad-mouth your current and previous employer</li>
          <li>Only ask about the salary if the interviewer speaks about it</li>
          <li>Feel free to ask questions when the interviewer give you a chance</li>
        </ol>
      </mat-expansion-panel>
    <!-- </mat-accordion> -->
  </div>
</section>
